module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-content-wrapper"
  }, [_c('div', {
    staticClass: "product-content-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mikmak-logo-new.png"),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), (_vm.product.patentPending) ? _c('span', {
    staticClass: "patent-pending"
  }, [_vm._v("patent pending")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-content-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), (_vm.product.bullets.length > 0) ? _c('div', {
    staticClass: "product-content-bullets"
  }, _vm._l((_vm.product.bullets), function(bullet) {
    return _c('span', {
      domProps: {
        "innerHTML": _vm._s(bullet)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "product-cta"
  }, [_c('a', {
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.logProductClick(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.cta))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b52aa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/products/ProductDetails.vue
// module id = 469
// module chunks = 0